import { render, staticRenderFns } from "./SearchArticles.vue?vue&type=template&id=1e803406"
import script from "./SearchArticles.vue?vue&type=script&lang=js"
export * from "./SearchArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports